import { useEffect } from 'react'

export const useParallaxVars = () => {
  useEffect(() => {
    let frameId: number | null = null
    let scrollY = window.scrollY
    let mouseX = 0

    const writeVars = () => {
      const rootStyle = document.documentElement.style
      rootStyle.setProperty('--scroll-y', String(scrollY))
      rootStyle.setProperty('--mouse-x', String(mouseX))
      frameId = null
    }

    const requestWrite = () => {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(writeVars)
      }
    }

    const handleScroll = () => {
      scrollY = window.scrollY
      requestWrite()
    }

    const handleMouseMove = (event: MouseEvent) => {
      mouseX = (event.clientX / window.innerWidth - 0.5) * 30
      requestWrite()
    }

    writeVars()
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('mousemove', handleMouseMove, { passive: true })

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])
}
